<template>
  <div>
    <NavigationBar
      titel="Validierungsregel anlegen"
      showBackBtn
      :actions="actions"
    ></NavigationBar>
    <section>
      <v-form
        @submit.prevent="createItem"
        ref="form"
        v-model="helpers.formIsValid"
      >
        <validation-rule-editor
          v-model="validationRule"
          mode="new"
        ></validation-rule-editor>
      </v-form>
    </section>
  </div>
</template>

<script>
import { Timestamp } from "@/firebase";
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import { CREATE_PERFORMANCE_TARGET } from "@/store/action-types.js";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import ValidationRuleEditor from "@/components/accounting/ValidationRuleEditor.vue";

export default {
  name: "member-management-performance-targets-new",
  components: {
    NavigationBar,
    ValidationRuleEditor,
  },
  data() {
    return {
      actions: [
        {
          title: "Erstellen",
          icon: "mdi-plus-circle",
          actionStyle: "textBtnSubmit",
          function: this.createItem,
        },
      ],
      validationRule: {
        title: "",
        description: "",
        priority: Number,
        isActive: true,
        conditions: { logicalOperator: "all", conditions: [] },
        applicableDivisionIds: [],
        monitoringInterval: { value: null, unit: null },
        dataVariables: [],
        validFrom: { date: null, time: "00:00" },
        validUntil: { date: null, time: "23:59" },
      },
      helpers: {
        formIsValid: false,
      },
    };
  },
  computed: {
    newPriority() {
      return this.$store.state.memberManagement.performanceTargets.length + 1;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.performanceTarget.priority = this.newPriority;
    },
    validate() {
      this.$refs.form.validate();
    },
    createItem() {
      this.validate();
      if (this.helpers.formIsValid) {
        this.$store.dispatch(
          `${MEMBER_MANAGEMENT}${CREATE_PERFORMANCE_TARGET}`,
          {
            organizationId: this.$route.params.organizationId,

            title: this.performanceTarget.title,
            shortTitle: this.performanceTarget.shortTitle,
            priority: this.performanceTarget.priority,
            isActive: this.performanceTarget.isActive,
            validFrom: {
              timestamp: this.convertToTimestamp(
                this.performanceTarget.validFrom.date,
                this.performanceTarget.validFrom.time
              ),
            },
            validUntil: {
              timestamp: this.convertToTimestamp(
                this.performanceTarget.validUntil.date,
                this.performanceTarget.validUntil.time
              ),
            },
            applicableDivisionIds: this.performanceTarget.applicableDivisionIds,
            monitoringInterval: {
              unit: this.performanceTarget.monitoringInterval.unit,
              value: this.performanceTarget.monitoringInterval.value,
            },
            dataVariables: this.performanceTarget.dataVariables,
            conditions: {
              logicalOperator:
                this.performanceTarget.conditions.logicalOperator,
              conditions: this.performanceTarget.conditions.conditions,
            },
          }
        );
      } else {
        alert("Prüfe Deine Eingabe und versuche es erneut.");
      }
    },
    convertToTimestamp(date, time) {
      const input = date + " " + time;
      return Timestamp.fromDate(new Date(input.replace(/-/g, "/")));
    },
  },
};
</script>

<style></style>
